/* Mobile Footer Accordion*/ 
document.addEventListener("DOMContentLoaded", function () {
  function initFooterAccordion() {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const footerBlocks = document.querySelectorAll(".footer-block");

    footerBlocks.forEach(block => {
      const heading = block.querySelector(".footer-block__heading");

      // Remove previous listeners to avoid duplicates
      heading.replaceWith(heading.cloneNode(true));
    });

    if (isMobile) {
      footerBlocks.forEach(block => {
        const heading = block.querySelector(".footer-block__heading");
        heading.addEventListener("click", () => {
          block.classList.toggle("open");
        });
      });
    } else {
      // Ensure everything is expanded on desktop
      footerBlocks.forEach(block => block.classList.add("open"));
    }
  }

  // Run on load
  initFooterAccordion();

  // Run again if screen resizes (mobile <-> desktop switch)
  window.addEventListener("resize", initFooterAccordion);
});
/* Diamond Shape selection js*/ 
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".custom-track");
  if (!track) return; // exit if not found
  let slides = Array.from(track.children);
  const prevBtn = document.querySelector(".custom-prev");
  const nextBtn = document.querySelector(".custom-next");

  let perPage = window.innerWidth < 768 ? 1 : 5;
  let startIndex = perPage;
  let currentIndex = startIndex; // ✅ start with first real slide centered

  // 🔥 Clone first & last slides for infinite loop
  const prependClones = slides.slice(-perPage).map(slide => slide.cloneNode(true));
  const appendClones = slides.slice(0, perPage).map(slide => slide.cloneNode(true));

  prependClones.forEach(clone => track.insertBefore(clone, slides[0]));
  appendClones.forEach(clone => track.appendChild(clone));

  slides = Array.from(track.children);

  const contentSlides = document.querySelectorAll(".shape-content-slide");

  function syncContentSlide() {
    const activeSlide = document.querySelector(".custom-slide.active");
    if (!activeSlide || !contentSlides.length) return;

    const index = activeSlide.getAttribute("data-shape-index");

    contentSlides.forEach(slide => {
      slide.classList.toggle(
        "active",
        slide.getAttribute("data-shape-index") === index
      );
    });
  }

  function updateSlider(animate = true) {
    const slideWidth = slides[0].getBoundingClientRect().width;
    const sliderWidth = document.querySelector(".custom-track-wrapper").offsetWidth;

    // ✅ Center exactly ONE slide
    const offset = slides[currentIndex].offsetLeft - (sliderWidth / 2 - slideWidth / 2);

    track.style.transition = animate ? "transform 0.4s ease" : "none";
    track.style.transform = `translateX(-${offset}px)`;

    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === currentIndex);
    });
    syncContentSlide();
  }

  function nextSlide() {
    currentIndex++;
    updateSlider();

    if (currentIndex >= slides.length - perPage) {
      setTimeout(() => {
        currentIndex = startIndex;
        updateSlider(false);
      }, 400);
    }
  }

  function prevSlide() {
    currentIndex--;
    updateSlider();

    if (currentIndex < perPage) {
      setTimeout(() => {
        currentIndex = slides.length - perPage * 2;
        updateSlider(false);
      }, 400);
    }
  }

  nextBtn.addEventListener("click", nextSlide);
  prevBtn.addEventListener("click", prevSlide);

  window.addEventListener("resize", () => {
    perPage = window.innerWidth < 768 ? 1 : 5;
    startIndex = perPage;
    currentIndex = startIndex;
    updateSlider(false);
  });

  updateSlider(false);
});

 /* Tab code with product swatch code*/ 
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab-button');
  const contents = document.querySelectorAll('.tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const handle = tab.dataset.collectionHandle;
      contents.forEach(content => {
        content.classList.toggle('active', content.dataset.collectionHandle === handle);
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {

  // Fallback if Shopify.formatMoney not available
  if(typeof Shopify === 'undefined') window.Shopify = {};
  if(typeof Shopify.formatMoney !== 'function') {
    Shopify.formatMoney = function(cents, format) {
      return (cents / 100).toFixed(2) + " {{ shop.currency }}";
    }
  }

  document.querySelectorAll('.product-item').forEach(item => {
  
    const swatches = item.querySelectorAll('.swatch');
    const mainImage = item.querySelector('.featured-image');
    const productLink = item.querySelector('.product_link');
    const priceEl = item.querySelector('.product-price');

    swatches.forEach(swatch => {
      swatch.addEventListener('click', function(e) {
       
        e.preventDefault();

        // Remove active from all swatches
        swatches.forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');

        // Update main image
        if(mainImage && swatch.dataset.image) {
          mainImage.src = swatch.dataset.image;
        }

        // Update product link
        if(productLink) {
          const url = new URL(productLink.href);
          url.searchParams.set('variant', swatch.dataset.variantId);
          productLink.href = url.toString();
        }

        // Update price
        if(priceEl && swatch.dataset.price) {
          const priceCents = parseInt(swatch.dataset.price, 10);
          priceEl.innerText = Shopify.formatMoney(priceCents, theme.moneyFormat);
        }
      });
    });
  });
});

/* Accordion Section js*/
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach(accordion => {
    const headers = accordion.querySelectorAll(".accordion-header");

    headers.forEach(header => {
      header.addEventListener("click", () => {
        const content = header.nextElementSibling;
        const expanded = header.getAttribute("aria-expanded") === "true";

        // Close only inside this accordion
        headers.forEach(h => {
          h.setAttribute("aria-expanded", "false");
          h.nextElementSibling.style.maxHeight = null;
        });

        // Open current if not already expanded
        if (!expanded) {
          header.setAttribute("aria-expanded", "true");
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    });
  });
}); 


/* back to top*/ 
document.addEventListener("DOMContentLoaded", function () {
  const backToTopBtn = document.getElementById("backToTop");

  if (backToTopBtn) {
    // Show, hide, and toggle sticky on scroll
    window.addEventListener("scroll", function () {
      if (window.scrollY > 300) {
        backToTopBtn.style.display = "block";
        backToTopBtn.classList.add("sticky"); // make it fixed
      } else {
        backToTopBtn.style.display = "none";
        backToTopBtn.classList.remove("sticky");
      }
    });

    // Smooth scroll to top on click
    backToTopBtn.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
});




/* FAQ Form Search Functionality*/

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('faq-search-form');
  
  // ✅ Only run if the search form exists
  if (!form) return;

  const input = document.getElementById('faq-search-input');
  const contactForm = document.getElementById('ContactForm');
  
  // ✅ Make sure JS targets the correct div ID
  const messageBox = document.getElementById('faq-search-message');

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const searchTerm = input.value.trim().toLowerCase();
    if (!searchTerm) return;

    // Reset previous message
    if (messageBox) {
      messageBox.style.display = 'none';
      messageBox.textContent = '';
    }

    let foundItem = null;
    let foundGroup = null;

    const allGroups = document.querySelectorAll('.multicolumn-card__info');
    allGroups.forEach(group => {
      const titles = group.querySelectorAll('.accordion-title');
      titles.forEach(title => {
        const questionText = title.textContent.trim().toLowerCase();
        if (questionText.includes(searchTerm) && !foundItem) {
          foundItem = title;
          foundGroup = group;
        }
      });
    });

    if (foundItem && foundGroup) {
      // Only open hidden items in matching group
      foundGroup.querySelectorAll('.accordion-item[style*="display: none"]').forEach(item => {
        item.style.display = 'block';
      });

      const parentAccordion = foundItem.closest('.accordion-item');
      const accordionContent = parentAccordion.querySelector('.accordion-content');
      const accordionHeader = parentAccordion.querySelector('.accordion-header');

      accordionContent.style.display = 'block';
      accordionHeader.setAttribute('aria-expanded', 'true');

      const inner = foundItem.closest('.multicolumn-card__info_inner');
      if (inner && inner.classList.contains('show-less')) inner.classList.remove('show-less');

      foundItem.style.backgroundColor = '#fff8c4';
      foundItem.style.transition = 'background-color 0.3s ease';
      parentAccordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => { foundItem.style.backgroundColor = 'transparent'; }, 2500);
    } else {
      // ✅ Show professional message
      if (messageBox) {
        messageBox.textContent = "We couldn’t find an answer to your question. Please use the form below, and our team will be happy to assist you.";
        messageBox.style.display = 'block';
        messageBox.style.opacity = '1';
        messageBox.style.transition = 'opacity 0.4s ease';

        setTimeout(() => { messageBox.style.opacity = '0'; }, 4000);
        setTimeout(() => {
          messageBox.style.display = 'none';
          if (contactForm) {
            contactForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const firstInput = contactForm.querySelector('input, textarea');
            if (firstInput) firstInput.focus();
          }
        }, 4500);
      } else if (contactForm) {
        contactForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = contactForm.querySelector('input, textarea');
        if (firstInput) firstInput.focus();
      }
    }
  });
});

/* FAQ Form Search Functionality End */

// loyality program info page
if (window.innerWidth < 768){
  document.addEventListener('DOMContentLoaded', function() {
    const titles = document.querySelectorAll('.tps-membership-table-head [data-title]');
    titles.forEach(title => {
      title.addEventListener('click', function() {
        const targetClass = this.getAttribute('data-title');
        document.querySelectorAll('.tps-membership-table-body span').forEach(span => {
          span.style.display = 'none';
        });
        document.querySelectorAll('.tps-membership-table-body .tps-membership-benifits').forEach(span => {
          span.style.display = 'inline-block';
        });
        document.querySelectorAll('.tps-membership-table-body .' + targetClass).forEach(span => {
          span.style.display = 'inline-block';
        });
      });
    });
    titles.forEach(title => {
      title.addEventListener('click', function() {
        titles.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });
  });
}


